import { ref, onValue } from "firebase/database";

/**
 * Subscribe to league data in realtime
 */
export function subscribeLeague(db, leagueCode, callback) {
  if (!leagueCode) return () => {};

  const leagueRef = ref(db, `leagues/${leagueCode}`);

  const unsubscribe = onValue(leagueRef, (snapshot) => {
    const data = snapshot.val();
    callback(data);
  });

  return unsubscribe;
}

/**
 * Get schedule for a specific week
 */
export function getWeekSchedule(league, week) {
  if (!league || !league.season || !league.season.schedule) return null;
  return league.season.schedule[String(week)] || null;
}